import { combineEpics } from 'redux-observable';
import templateEpics from '../src/store/templates/epics';
import careCuesEpics from './store/careCues/epic';
import navigationEpics from './store/navigation/epics';
import selectedVisitEpics from './store/selectedVisit/epics';
import providerEpics from './store/provider/epics';
import authEpics from './store/auth/epics';
import noteReviewEpics from './store/noteReview/epics';
import adminEpics from '../src/store/admin/epics';
import noteEpics from './store/note/epics';
import appEpics from './store/app/epics';
import visitsEpics from './store/visits/epics';

export const rootEpic = combineEpics(
  ...templateEpics,
  ...careCuesEpics,
  ...noteEpics,
  ...navigationEpics,
  ...selectedVisitEpics,
  ...providerEpics,
  ...authEpics,
  ...noteReviewEpics,
  ...appEpics,
  ...adminEpics,
  ...visitsEpics,
);
